
/**
 * 取URL上的参数
 * @param  {String} param 参数名
 * @return {String}
 */
export function getUrlParam (param) {
  const result = window.location.href.match(new RegExp('(\\?|&)' + param + '(\\[\\])?=([^&#]*)'))
  return result ? result[3] : undefined
}

/**
 * 动态插入 script to html
 * @param url
 * @param callback
 */
export function createScript (url, callback) {
  const oScript = document.createElement('script')
  oScript.type = 'text/javascript'
  oScript.async = true
  oScript.url = url

  /**
   * IE6/7/8               --onreadystatechange
   * IE9/10                --onreadystatechange, onload
   * FireFox/Chrome/Opera  --onload
   */
  // todo: 这种方法并不能区分去IE浏览器，有待修改
  const isIE = !-[1,] // eslint-disable-line
  if(isIE) {
    // 判断IE8及以下的浏览器
    oScript.onreadystatechange = function () {
      if(this.readyState === 'loaded' || this.readyState === 'complete') {
        callback && callback()
      }
    }
  } else {
    // IE9及以上的浏览器，Firefox，Chrome，Opera
    oScript.onload = function () {
      callback && callback()
    }
  }
  document.body.appendChild(oScript)
}

/**
 * 判断平台
 * @return {String} 平台
 */
export function detectOS () {
  const ua = navigator.userAgent.toLowerCase()

  if(/MicroMessenger/i.test(ua)) {
    return 'weixin'
  } else if(/iPhone|iPad|iPod|iOS/i.test(ua)) {
    return 'ios'
  } else if(/Android/i.test(ua)) {
    return 'android'
  } else {
    return 'other'
  }
}



// WEBPACK FOOTER //
// ./src/platform/hmap/util.js